class OfferPopup extends ModalDialog {
  constructor() {
    super();
    this.cookieDuration = 3;
    this.delay = this.dataset.delay * 1000;
    this.cookieName = this.dataset.cookie || 'offer-popup-closed';
    this.ageVerificationPopup = document.querySelector('age-verification-popup');

    this.querySelectorAll('.js-button-close').forEach(button => button.addEventListener('click', this.dismiss.bind(this)));
    this.querySelector('.js-offer-cta')?.addEventListener('click', () => this.saveDismissCookie());
    this.addEventListener('click', event => {
      if (event.target === this) this.dismiss();
    });
  }

  saveDismissCookie() {
    setCookie(this.cookieName, 'true', this.cookieDuration);
  }

  dismiss() {
    this.saveDismissCookie();
    this.hide();
  }

  connectedCallback() {
    super.connectedCallback();
    // Moving the node to <body> re-fires connectedCallback.
    if (this.initialized) return;
    this.initialized = true;

    if (Shopify.designMode) {
      if (this.dataset.openInDesignMode === 'true') this.show();
      return;
    }

    if (getCookie('age-verified') !== 'true' && this.ageVerificationPopup) {
      this.waitForAgeVerification();
    } else {
      this.showWithDelay();
    }
  }

  waitForAgeVerification() {
    const observer = new MutationObserver(() => {
      if (getCookie('age-verified') === 'true') {
        observer.disconnect();
        this.showWithDelay();
      }
    });
    observer.observe(this.ageVerificationPopup, { attributes: true });
  }

  showWithDelay() {
    setTimeout(() => {
      if (getCookie(this.cookieName) !== 'true') this.show();
    }, this.delay);
  }
}

if (!customElements.get('offer-popup')) {
  customElements.define('offer-popup', OfferPopup);
}
